import React from "react";
import { Box, Grid, Skeleton, Stack } from "@mui/material";

/**
 * Skeleton loader for the My Staking Pools page. Mirrors the layout
 * (back link → header + CTA → pool cards) so the loading state has
 * the same shape as the loaded page.
 */
export default function StakingPoolsSkeleton() {
  return (
    <Box sx={{ flex: 1, minWidth: 0, px: 2, display: "flex" }}>
      <Box sx={{ width: "100%", minWidth: 0 }}>
        {/* Back link */}
        <Skeleton variant="text" width={140} height={28} sx={{ mb: 2 }} />

        {/* Header row: icon + title/subtitle + CTA button */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 2,
            mb: 3,
            flexWrap: "wrap",
          }}
        >
          <Stack direction="row" spacing={2} alignItems="center">
            <Skeleton variant="rounded" width={50} height={50} sx={{ borderRadius: 1 }} />
            <Box>
              <Skeleton variant="text" width={220} height={36} />
              <Skeleton variant="text" width={320} height={20} />
            </Box>
          </Stack>
          <Skeleton variant="rounded" width={190} height={44} sx={{ borderRadius: "12px" }} />
        </Box>

        {/* Pool card rows */}
        <Stack spacing={2.5}>
          {[0, 1].map((i) => (
            <Box
              key={i}
              sx={{
                p: 3,
                borderRadius: 1.5,
                bgcolor: "background.subtle",
              }}
            >
              <Stack
                direction={{ xs: "column", sm: "row" }}
                justifyContent="space-between"
                alignItems={{ xs: "flex-start", sm: "flex-start" }}
                spacing={2}
                mb={3}
              >
                <Stack direction="row" spacing={2} alignItems="flex-start">
                  <Skeleton variant="rounded" width={48} height={48} sx={{ borderRadius: 1.25 }} />
                  <Box>
                    <Skeleton variant="text" width={200} height={26} />
                    <Stack direction="row" spacing={1} sx={{ mt: 0.75 }}>
                      <Skeleton variant="rounded" width={110} height={22} sx={{ borderRadius: 999 }} />
                      <Skeleton variant="rounded" width={70} height={22} sx={{ borderRadius: 999 }} />
                    </Stack>
                    <Skeleton variant="text" width={160} height={18} sx={{ mt: 0.75 }} />
                  </Box>
                </Stack>
                <Box sx={{ textAlign: { xs: "left", sm: "right" } }}>
                  <Skeleton variant="text" width={80} height={16} sx={{ ml: { sm: "auto" } }} />
                  <Skeleton variant="text" width={70} height={36} sx={{ ml: { sm: "auto" } }} />
                </Box>
              </Stack>

              <Grid container spacing={3}>
                {[0, 1, 2, 3].map((j) => (
                  <Grid size={{ xs: 6, md: 3 }} key={j}>
                    <Skeleton variant="text" width={70} height={16} />
                    <Skeleton variant="text" width={90} height={22} />
                  </Grid>
                ))}
              </Grid>
            </Box>
          ))}
        </Stack>
      </Box>
    </Box>
  );
}
